'use strict';

function allCharsReg(src) {
  return RegExp('[' + src + ']', 'g');
}

module.exports = allCharsReg;


// WEBPACK FOOTER //
// ./~/sugar-date/common/internal/allCharsReg.js